/* eslint-disable no-param-reassign */
export default {
  connected() {
    this.resiableColmunHeaders = this.headerRow.querySelectorAll('tr-grid-resize-cell');
    this.resizableStickyColumnHeader = Array.from(this.resiableColmunHeaders)
      .find(item => item.syncKey === 'stickyCell');
  },

  ready() {
    this.resiableColmunHeaders.forEach((item) => {
      this.broadcastSubjectEvent('columnResized', {
        syncKey: item.syncKey, width: item.width,
      });
    });

    this.listenTo(this, 'tr-grid-resize-cell:resized', (e) => {
      if (e.detail.syncKey === 'stickyCell') {
        this.resizableStickyColumnHeader.width = e.detail.width; // From group title resizing
        this.updateHeaderStickyCellWidth(e.detail.width);
      } else {
        this.updateStickyColumnRange();
      }
      this.broadcastSubjectEvent('columnResized', e.detail);
    });

    const maxWidth = this.calcStickyColumnMaxWidth();
    if (!this.resizableStickyColumnHeader) {
      this.updateHeaderStickyCellWidth(maxWidth);
      this.broadcastSubjectEvent('columnResized', {
        syncKey: 'stickyCell', width: maxWidth,
      });
      return;
    }
    this.updateHeaderStickyCellWidth(this.resizableStickyColumnHeader.width);

    this.updateStickyColumnRange({ max: maxWidth });
    if (this.getUnstickyColumnHeaders().length === 0) {
      this.resizableStickyColumnHeader.resize(maxWidth);
    } else if (this.resizableStickyColumnHeader.width > this.resizableStickyColumnHeader.max) {
      this.resizableStickyColumnHeader.resize(this.resizableStickyColumnHeader.max);
    }
    this.resizableStickyColumnHeader.snapshot();
  },
};
